import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { rootModel } from 'src/app/models/rootModel';

@Component({
  selector: 'app-pages-layout',
  templateUrl: './pages-layout.component.html',
  styleUrls: ['./pages-layout.component.css']
})
export class PagesLayoutComponent implements OnInit {

  rootModel:rootModel = new rootModel();

  constructor(private route:ActivatedRoute) { }

  ngOnInit(): void {    

    
    this.route.paramMap.subscribe(params=>{
      console.log(params); 
    })


  }



  prevdeneme(event){

  }
}
